<template>
  <footer>
    <div class="site-footer bg-gris py-5 border-t-2 border-gris z-50">
      <div class="md:grid md:grid-cols-2 mx-[10%]">
        <div class="px-5 mx-auto pt-5 pb-10 md:pb-0">
          <div class="pb-5">
            <h2 class="text-2xl font-bold text-white">Suivez‑nous</h2>
            <hr class="w-36 h-1  bg-blue-base border-0 rounded">
          </div>

          <!-- Social links: inline SVGs to inherit currentColor -->
          <div v-for="i in facebook" class="pb-5 pl-5">
            <a class="flex items-center text-white hover:text-blue-500 transition-colors duration-200" href="https://www.instagram.com/telecomnancyservices" target="_blank" rel="noopener noreferrer">
              <!-- Instagram SVG (paths adapted to use currentColor) -->
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 598.2047 557.0656" class="w-[30px] h-[30px] flex-shrink-0 text-current" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="M14.57 101.39c0-48.819 39.576-88.395 88.395-88.395h391.02c23.444 0 45.928 9.3131 62.505 25.89 16.577 16.577 25.89 39.061 25.89 62.505v353.57c0 48.819-39.576 88.395-88.395 88.395h-391.02c-48.819 0-88.395-39.576-88.395-88.395z" stroke="currentColor" stroke-width="24" fill="none" />
                <path d="M175.85 327.57c0-62.56 52.365-113.28 116.96-113.28 31.02 0 60.769 11.934 82.704 33.178 21.934 21.243 34.257 50.055 34.257 80.098 0 62.56-52.365 113.28-116.96 113.28-64.596 0-116.96-50.715-116.96-113.28z" stroke="currentColor" stroke-width="24" fill="none" />
                <path d="M464.29 97.16c0-15.125 12.205-27.386 27.26-27.386 7.2298 0 14.163 2.8853 19.276 8.0211 5.1122 5.1358 7.9842 12.102 7.9842 19.365 0 15.125-12.205 27.386-27.26 27.386s-27.26-12.261-27.26-27.386z" fill="currentColor" />
              </svg>
              <span class="ml-3 text-current">{{ i.name }}</span>
            </a>
          </div>

          <div v-for="i in facebook" class="pb-5 pl-5">
            <a class="flex items-center text-white hover:text-blue-500 transition-colors duration-200" :href="i.link" target="_blank" rel="noopener noreferrer">
              <!-- Facebook SVG inline -->
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-[30px] h-[30px] flex-shrink-0 text-current" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
              </svg>
              <span class="ml-3 text-current">{{ i.name }}</span>
            </a>
          </div>

          <div v-for="i in linkedin" class="pb-5 pl-5">
            <a class="flex items-center text-white  hover:text-blue-500 transition-colors duration-200" :href="i.link" target="_blank" rel="noopener noreferrer">
              <!-- LinkedIn SVG inline (use fill=currentColor on shapes to inherit link color) -->
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-[30px] h-[30px] flex-shrink-0" aria-hidden="true">
                <path fill="currentColor" d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
                <rect fill="currentColor" x="2" y="9" width="4" height="12" />
                <circle fill="currentColor" cx="4" cy="4" r="2" />
              </svg>
              <span class="ml-3 text-current">{{ i.name }}</span>
            </a>
          </div>
        </div>
        <div class="px-5 block">
          <div>
            <img alt="Logo Telecom Nancy Services" :src="currentFooterLogo" class="m-auto w-[40%]" loading="lazy" decoding="async">
          </div>
          <div class="footer-text text-white text-center space-y-1">
            <div>
              <a class="hover:text-blue-500" href="https://www.google.fr/maps/place/TELECOM+Nancy/@48.6690814,6.1551443,20.39z/data=!4m9!1m2!2m1!1s193,+avenue+Paul+Muller+54602+Villers-l%C3%A8s-Nancy!3m5!1s0x4794a27b958c5c31:0xda674138b6da42e7!8m2!3d48.6691262!4d6.155318!15sCjAxOTMsIGF2ZW51ZSBQYXVsIE11bGxlciA1NDYwMiBWaWxsZXJzLWzDqHMtTmFuY3mSAQ9ncmFkdWF0ZV9zY2hvb2zgAQA"
                 target="_blank" rel="noopener noreferrer">
                <p>193, avenue Paul Muller 54602 Villers-lès-Nancy</p></a>
            </div>

            <div>
              <a class="hover:text-blue-500" href="tel:0778436881"><p>+33 (0)7 78 43 68 81</p></a>
            </div>

            <div>
              <a class="hover:text-blue-500" href="mailto:contact@tnservices.fr"><p>contact@tnservices.fr</p></a>
            </div>

            <div class="pt-2 font-bold">
              <p class="hover:text-blue-500">
                <router-link :to="{name: 'contact'}" class="router-link">Nous contacter</router-link>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-copy text-center text-gray-300 pt-2">
        <p>© {{new Date().getFullYear()}} TNServices</p>
        <p>Conception <a class="hover:text-blue-500" href="https://www.linkedin.com/in/silvio-brancati-82970219b/" target="_blank" rel="noopener noreferrer">Silvio Brancati</a> - <a class="hover:text-blue-500" href="https://www.linkedin.com/in/anthony-briot-7521a3218/" target="_blank" rel="noopener noreferrer">Anthony Briot</a> - <a class="hover:text-blue-500" href="https://www.linkedin.com/in/mat%C3%A9o-demangeon-6962a4208/" target="_blank" rel="noopener noreferrer">Matéo Demangeon</a></p>
      </div>
    </div>
  </footer>
</template>

<script>
import { useTheme } from '@/composables/useTheme'
import { FOOTER_LINKS } from '@/data/siteContent'
export default {
  name: 'Footer',
  setup() {
    const { isDark } = useTheme()

    return {
      isDark,
    }
  },
  data() {
    return {
      logoDark: '/assets/images/tns_logo_complet_blanc_fond_transparent_300ppp.png',
      logoLight: '/assets/images/tns_logo_complet_couleur_fond_transparent_72dpi.png',
      facebook: FOOTER_LINKS.facebook,
      linkedin: FOOTER_LINKS.linkedin,

    }
  },
  computed: {
    currentFooterLogo() {
      return this.isDark ? this.logoDark : this.logoLight
    },
  },
}
</script>

<style>
</style>